import React from 'react'
import USTemplateDefault from 'src/components/template/us'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/redsox-nesn-15s.mp4'}
      title="Watch the Boston Red Sox"
      subtitle="Live on NESN all season long. Regional restrictions apply."
      networkSet="baseball"
      customNetworks={['nesn']}
    />
  )
}
